<template>
  <div>
    <el-badge :value="alertCount">
      <el-button type="text" icon="fa-solid fa-bell" style="padding: 0 !important;font-size: 2rem;color:orange"
        @click="showModal = true; getAlert();">
      </el-button>
    </el-badge>
    <div>
      <el-dialog :title="$t('Gecikmələr')" @close="closeDialog()" :visible.sync="showModal" width="40%" top="5vh"
        append-to-body>
        <div v-for="(statusTypeId, i) in alerttypes" :key="i"
          style="overflow: hidden; margin-bottom: 20px;margin-right: 10px;">
          <alert-badge :id="statusTypeId" :title="alertTitle(statusTypeId)" :alertType="alertStyle(statusTypeId)"
            :data="alert.filter((c) => c.statusTypeId === statusTypeId)"
            :count="alert.filter((c) => c.statusTypeId === statusTypeId).length" @click="clickBadge" />
        </div>
        <transition name="el-fade">
          <div v-show="showAlert">
            <alert :readonly="stage === 1 ? true : false" :pathname="pathName" ref="alertPanel" @close="closeBadge" />
          </div>
        </transition>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Alert from "../components/Alert.vue";
import AlertBadge from "../components/AlertBadge.vue";
import { AccidentStatusAlert } from "src/services/common";

export default {
  mounted() {
    this.getAlert();
  },
  components: {
    Alert,
    AlertBadge,
  },
  computed: {
    pathName() {
      if (this.$route.matched[0].path === '/act') return '/servicecenter'
      if (this.$route.matched[0].path === '/approval') return '/servicecenter'
      return this.$route.matched[0].path;
    },
    stage() {
      return this.$route.meta.stage;
    },
    alertCount() {
      return this.alert.filter(m => m.stage === this.stage).length
    },
  },
  data() {
    return {
      showModal: false,
      alert: [],
      alerttypes: [],
      showAlert: false
    };
  },
  methods: {
    getAlert() {
      AccidentStatusAlert().then((response) => {
        if (response.data.data) {
          this.alert = response.data.data;
          this.alerttypes = [
            ...new Set(
              response.data.data
                .filter((c) => c.stage === this.stage)
                .map((item) => item.statusTypeId)
            ),
          ];
        }
      });
    },
    closeDialog() {
      this.closeBadge();
    },
    clickBadge(val) {
      let reg = this.alert.filter((c) => c.statusTypeId === val);
      this.$refs.alertPanel.data = reg;
      this.$refs.alertPanel.statusTypeId = this.alertStyle(val);
      this.showAlert = true;
    },
    closeBadge() {
      this.showAlert = false;
      this.$refs.alertPanel.data = [];
    },
    alertTitle(val) {
      switch (val) {
        case 1:
          return this.$t('Qəza_komissarına_ötürülməyib');
        case 5:
          return this.$t('ş_qəbul_olunmayıb');
        case 10:
          return this.$t('Müştəri_xidmətinə_ötürülməyib');
        case 11:
          return this.$t('QK_rəhbərinə_təsdiqə_göndərilib');
        case 12:
          return this.$t('QK_təyinatı_ləğv_edib');
        case 13:
          return this.$t('QK_Tələbdən_imtina_edib');
        case 14:
          return this.$t('QK_rəhbəri_hadisəni_geri_qaytarıb');
        case 30:
          return this.$t('ş_qəbul_olunmayıb');
        case 35:
          return this.$t('Məsul_şəxs_təyin_olunmayıb');
        case 40:
          return this.$t('ş_yaradılmayıb');
        case 45:
          return this.$t('DYP_sənədləri_hazır_deyil');
        case 50:
          return this.$t('ş_texniki_ekspertizaya_ötürülməyib');
        case 70:
          return this.$t('Məsul_şəxs_təyin_olunmayıb');
        case 75:
          return this.$t('Daxili_qiymətləndirmə_başlanmayıb');
        case 80:
          return this.$t('Daxili_qiymətləndirmə_təsdiqə_göndərilməyib');
        case 85:
          return this.$t('Daxili_qiymətləndirmə_razılaşdırılmağa_göndərilməy');
        case 90:
          return this.$t('Daxili_qiymətləndirmənin_qərarı_verilməyib');
        case 95:
          return this.$t('TM_qiymətləndirmə_göndərilməyib');
        case 100:
          return this.$t('TM_qiymətləndirmə_razılaşdırılmağa_göndərilməyib');
        case 105:
          return this.$t('TM_qiymətləndirmənin_qərarı_verilməyib');
        case 110:
          return this.$t('Təmir_başlamayıb');
        case 115:
          return this.$t('ME_qiymətləndirmə_razılaşdırılmağa_göndərilməyib');
        case 120:
          return this.$t('ME_qiymətləndirmənin_qərarı_verilməyib');
        case 125:
          return this.$t('Qiymət_razılaşdırılmayıb');
        case 130:
          return this.$t('Təmir_yekunlaşmayıb');
        case 131:
          return this.$t('Müştəri_xidmətinə_göndərilməyib_Təmir');
        case 135:
          return this.$t('Müştəri_xidmətinə_göndərilməyib_Razılaşma');
        case 145:
          return this.$t('Məsul_şəxs_təyin_olunmayıb');
        case 146:
          return this.$t('Aktlaşdırma_başlanmayıb');
        case 150:
          return this.$t('Təsdiqlənməyə_göndərilməyib');
        case 151:
          return this.$t('Təsdiqə_göndərilib');
        case 160:
          return this.$t('Ödənişə_başlanmayıb');
        case 161:
          return this.$t('Ödəniş_olunmayıb');
      }
    },
    alertStyle(val) {
      switch (val) {
        case 1:
          return "#FFA500";
        case 5:
          return "#FF7F50";
        case 10:
          return "#643843";
        case 11:
          return "#FFA500";
        case 12:
          return "#FF0000"
        case 13:
          return "#800000"
        case 14:
          return "#B3005E"
        case 30:
          return "#FF7F50";
        case 35:
          return "#DAA520";
        case 40:
          return "#A52A2A";
        case 45:
          return "#E9967A";
        case 50:
          return "#FFA500";
        case 70:
          return "#B22222";
        case 75:
          return "#FF0000";
        case 80:
          return "#FF8C00";
        case 85:
          return "#808000";
        case 90:
          return "#FFD700";
        case 95:
          return "#008000";
        case 100:
          return "#228B22";
        case 105:
          return "#00FF00";
        case 110:
          return "#0000CD";
        case 115:
          return "#A52A2A";
        case 120:
          return "#ADFF2F";
        case 125:
          return "#FF7F50";
        case 130:
          return "#E9967A";
        case 131:
          return "#4B0082";
        case 135:
          return "#6495ED";
        case 145:
          return "#B22222";
        case 146:
          return "#FF0000";
        case 150:
          return "#FF8C00";
        case 151:
          return "#FFA500";
        case 161:
          return "#FF8C00";
        case 162:
          return "#E9967A";
        default:
          return "#808080";

      }
    },
  },
};
</script>

<style scoped></style>